import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        wrapper: {
            height: '100%',
            display: 'flex',
            width: '320px',
        },
    }
})

export default useStyles
